import { Info } from 'lucide-react';
import { useEnteringFor } from '@/contexts/EnteringForContext';

/**
 * Full-width info bar rendered directly below the timesheet toolbar when a user
 * is entering time on behalf of another person.
 *
 * Hidden automatically when the user has switched back to "Myself".
 */
export function EnteringForBanner() {
  const { isEnteringForOther, selectedPerson, setSelectedPersonId } = useEnteringFor();

  if (!isEnteringForOther || !selectedPerson) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="flex items-center gap-3 rounded-md px-4 py-2.5 text-sm
                 bg-teal-50 border border-teal-200 text-teal-900
                 dark:bg-teal-950/40 dark:border-teal-800 dark:text-teal-100"
    >
      <Info className="h-4 w-4 flex-shrink-0 text-teal-600 dark:text-teal-400" />

      <p className="flex-1">
        You are entering time for{' '}
        <strong className="font-semibold">{selectedPerson.name}</strong>.{' '}
        Their projects, cost centres, and approval workflow apply.
      </p>

      <button
        type="button"
        onClick={() => setSelectedPersonId(null)}
        className="flex-shrink-0 text-teal-700 underline underline-offset-2
                   hover:text-teal-900 focus-visible:outline-none
                   focus-visible:ring-2 focus-visible:ring-teal-500 rounded
                   dark:text-teal-300 dark:hover:text-teal-100
                   text-sm font-medium whitespace-nowrap"
      >
        Switch back to my timesheet
      </button>
    </div>
  );
}
